const setHeaderUploader = () => {
  return {
    headers: {
      encType: 'multipart/form-data',
      type: 'formData',
    },
  };
};
export default setHeaderUploader;
